module.exports = __webpack_public_path__ + "static/22-85f78866a6fd04eb0915bd76025b46fe.png";